import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { CommonService } from 'src/app/shared/utils/common.service';

@Component({
  selector: 'app-user-name',
  templateUrl: './user-name.component.html',
  styleUrls: ['./user-name.component.scss'],
})
export class UserNameComponent implements OnInit {
  /**
   * all necessary input get values from parent
   */
  @Input() formGroupName!: string;
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();

  holdPreviousState!: string;

  formGroup!: FormGroup;
  submited = false;

  readonly LANG_CONST = LANG_CONST;

  constructor(
    public rootFormGroup: FormGroupDirective,
    public commonService: CommonService
  ) {}

  /**
   * @description this is onInit life cycle method
   */
  ngOnInit(): void {
    this.formGroup = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;
    this.holdPreviousState = this.formGroup?.controls?.searchEntity.value;
  }

  updateForm(name: string) {
    this.formGroup.patchValue({
      searchEntity: name,
    });
  }
  /**
   * @description navigate to back screen
   * @returns void
   */
  navigateBack(): void {
    this.updateForm(this.holdPreviousState);
    this.stepperChange.emit((this.stepper = 1));
  }

  /**
   * @description validate form if form valid hold value into main form and redirect to next step
   * @returns void
   */
  submit(): void {
    this.submited = true;
    this.stepperChange.emit((this.stepper += -1));
  }

  removeUser() {
    this.updateForm('');
  }
}
